import MainLayout from "@/components/layout/MainLayout";
import RegisterForm from "@/components/auth/RegisterForm";
import { useTranslation } from "react-i18next";

const Register = () => {
  const { t } = useTranslation();

  return (
    <MainLayout>
      <div className="container-page flex items-center justify-center py-8 md:py-16">
        <div className="w-full max-w-md bg-card p-6 md:p-8 rounded-lg border shadow-sm">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold">{t('auth.register.title')}</h1>
            <p className="text-muted-foreground mt-1">{t('auth.register.subtitle')}</p>
          </div>

          <RegisterForm />

          <div className="mt-6 text-center text-sm text-muted-foreground">
            <p>{t('auth.register.agree_terms')}</p>
            <div className="mt-1">
              <a
                href="https://voice2doc.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-600 hover:underline"
              >
                {t('auth.register.terms_link')}
              </a>
              {t('auth.register.and')}
              <a
                href="https://voice2doc.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-600 hover:underline"
              >
                {t('auth.register.privacy_link')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Register;
